module.exports = __webpack_public_path__ + "static/media/frontpage.90daf690.jpg";